
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/informe-de-nieve",
      function () {
        return require("private-next-pages/[region]/[resort]/informe-de-nieve.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/informe-de-nieve"])
      });
    }
  